<template>
  <svg
    :class="svgClass"
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    v-if="show"
  >
    <defs>
      <pattern
        id="diagonalStripelabel"
        patternUnits="userSpaceOnUse"
        width="20"
        height="20"
        patternTransform="rotate(45)"
      >
        <rect width="20" height="20" :fill="backgroundColor" />
        <rect x="0" y="0" width="10" height="20" :fill="stripeColor" :opacity="stripeOpacity" />
      </pattern>
    </defs>
    <rect x="0" y="0" width="20" height="20" fill="url(#diagonalStripelabel)" />
  </svg>
</template>

<script>
export default {
  name: "SoldContingencyStatus",
  props: {
    svgClass: { type: String, default: "" },
    show: { type: Boolean, default: true },
    backgroundColor: { type: String, default: "#A76C5A" },
    stripeColor: { type: String, default: "#6E2F1FB2" },
    stripeOpacity: { type: Number, default: 0.7 }
  }
};
</script>
